<template>
    <div class="bg-neutral-100 dark:bg-neutral-800 rounded my-4 flex items-center justify-between cursor-pointer"
         @click="handleTemplateEdit">
        <div class="p-3 w-full">
            <div>
                {{ template.name }}
            </div>
            <div class="text-xs truncate text-neutral-500 w-full">
                {{ itemSummary }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ResourceListItem',
  computed: {
    itemSummary() {
      if (this.template.items?.length) {
        return this.template.items.map((item) => {
          if (item.type === 'rest_timer') {
            return `${item.label || 'Rest Timer'} (${this.$timerValue(item.duration || 90)})`;
          }

          const movementId = item.movementId || item.movement_id;
          const movement = this.template.movements.find(movement => movement.id === movementId);

          return movement?.name || 'Movement';
        }).join(', ');
      }

      return this.template.movements.map(movement => movement.name).join(', ');
    },
    template() {
      return this.resource;
    },
  },
  methods: {
    handleTemplateEdit() {
      this.$router.push(`/template/${this.template.uuid}/edit`);
    },
  },
  props: {
    resource: {
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">

</style>
